import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n";

export default function Guida() {
  const { l, data, t } = useLang();
  const { ARTICLES } = data;
  const p = t.guide;

  return (
    <>
      <Seo title={p.seo.title} description={p.seo.description} path="/guida" />
      <section className="max-w-7xl mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-12 md:pb-16">
        <Reveal>
          <p className="eyebrow mb-5">{p.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight text-ink max-w-3xl">
            {p.h1}
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-base md:text-lg text-body leading-relaxed max-w-2xl">
            {p.lead}
          </p>
        </Reveal>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-10 pb-20 md:pb-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={0.06 * i}>
              <Link
                to={l(`/guida/${a.slug}`)}
                data-testid={`article-card-${a.slug}`}
                className="group block img-frame bg-card h-full transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-24px_rgba(26,26,26,0.35)]"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="p-7 md:p-8">
                  <p className="flex items-center gap-3 text-xs text-body">
                    <span>{a.date}</span>
                    <span className="w-1 h-1 rounded-full bg-sand" aria-hidden="true" />
                    <span className="inline-flex items-center gap-1">
                      <Clock className="w-3.5 h-3.5" aria-hidden="true" /> {a.readTime} {p.minRead}
                    </span>
                  </p>
                  <h2 className="font-serif text-2xl md:text-3xl text-ink mt-4 leading-snug group-hover:text-sage transition-colors duration-300">
                    {a.title}
                  </h2>
                  <p className="mt-3 text-sm text-body leading-relaxed">{a.excerpt}</p>
                  <p className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-semibold text-sage">
                    {p.read}
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <p className="mt-12 text-xs text-body/70 leading-relaxed max-w-3xl">
          {p.credits}
        </p>
      </section>
    </>
  );
}
